/*
 * NotFoundPage Messages
 *
 * This contains all the text for the NotFoundPage component.
 */
import { defineMessages } from "utils/defineMessages";

export const scope = "app.scenes.NotFoundPage";

export default defineMessages(scope, {
  mainHeader: "We can’t seem to find the page you’re looking for.",
  errorCode: "Error code: 404",
});
